export default __webpack_public_path__ + "static/media/utility8.3876bfdd.svg";